export enum RescheduleInitiator {
	Learner = 1,
	Instructor = 2,
	Admin = 3
}

export interface ICommitRescheduleRequest {
	lessonID: number;
	proposedDate: string | null;
	propose: boolean;
	initiatedBy: RescheduleInitiator;
}
